// src/store/slices/toastSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    toast: {
        open: false,
        message: '',
        severity: 'info'
    }
};

const toastSlice = createSlice({
    name: 'toast',
    initialState,
    reducers: {
        showToast(state, action) {
            state.toast = {
                open: true,
                message: action.payload.message,
                severity: action.payload.severity || 'info'
            };
        },

        hideToast(state) {
            state.toast.open = false;
        },

        reset() {
            return initialState;
        }
    }
});

export const toastActions = toastSlice.actions;
export const toastReducer = toastSlice.reducer;